export function ensureUniqueName(existing: string[], desired: string): string {
  let suffix = 0;
  for (const n of existing) {
    if (n === desired || n.startsWith(desired + ' (')) {
      const match = n.match(/\((\d+)\)$/);
      if (match) {
        const num = parseInt(match[1]);
        if (num > suffix) suffix = num;
      } else if (suffix < 1) {
        suffix = 1;
      }
    }
  }
  return suffix > 0 ? `${desired} (${suffix + 1})` : desired;
}

